module.exports = __webpack_public_path__ + "static/media/sv-counter-bg.e1df769c.png";